'use client';

import { MenuItem, Pagination as MuiPagination, Select, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { PaginationDelegate } from "@/app/features/shared/__to_be_integrated/ui/pagination/types/PaginationDelegate";

interface PaginationControlProps {
    usePaginationDelegate: () => PaginationDelegate;
    ariaLabel?: string;
    disabled?: boolean;
}

const defaultPageSizes = [10, 25, 50, 100];

export default function PaginationControl({
    usePaginationDelegate,
    ariaLabel = 'Seitennavigation',
    disabled = false,
}: PaginationControlProps) {
    const {
        pageInfo,
        setPage,
        setPageSize,
        pageSizes = defaultPageSizes,
        showPageSize = true
    } = usePaginationDelegate();

    return (
        <Stack
            direction="row"
            spacing={4}
            className="w-full p-1 justify-center items-center"
        >
            <MuiPagination
                aria-label={ariaLabel}
                page={pageInfo.page}
                count={pageInfo.pageCount}
                onChange={(_, page) => setPage(page)}
                disabled={disabled}
                getItemAriaLabel={(type, page, selected) => {
                    if (type === 'page') {
                        return selected ? `Seite ${page}` : `Zu Seite ${page} wechseln`;
                    }
                    if (type === 'first') return 'Zur ersten Seite wechseln';
                    if (type === 'last') return 'Zur letzten Seite wechseln';
                    if (type === 'next') return 'Zur nächsten Seite wechseln';
                    if (type === 'previous') return 'Zur vorherigen Seite wechseln';
                    return 'Weitere Seiten';
                }}
                showFirstButton
                showLastButton
            />
            {showPageSize && (
                <Stack direction="row" spacing={2} alignItems="center">
                    <Typography variant="body1">Zeige</Typography>
                    <Select
                        variant="standard"
                        value={pageInfo.pageSize}
                        onChange={(event) =>
                            setPageSize(parseInt(event.target.value as string))
                        }
                    >
                        {(pageSizes || defaultPageSizes).map((size) =>
                            <MenuItem key={size} value={size}><Typography variant="body1">{size}</Typography></MenuItem>
                        )}
                    </Select>
                    <Typography variant="body1">von {pageInfo.total}</Typography>
                </Stack>
            )}
        </Stack>
    )
}
